import * as t from "io-ts"

export default t
